/**
 * First-party marketing analytics — deliberately dependency-free.
 *
 * Events are pushed onto `window.famanageEvents` and re-emitted as a
 * `famanage:track` CustomEvent, so any future tag manager or first-party
 * endpoint can subscribe without the page importing a vendor SDK. Nothing
 * leaves the visitor's browser today; no cookies, no fingerprinting.
 */
export interface TrackPayload {
  event: string;
  path: string;
  ts: number;
  [key: string]: string | number;
}

declare global {
  interface Window {
    famanageEvents?: TrackPayload[];
  }
}

export function track(event: string, props: Record<string, string | number> = {}): void {
  if (typeof window === 'undefined') return;
  const payload: TrackPayload = {
    event,
    path: window.location.pathname,
    ts: Date.now(),
    ...props,
  };
  window.famanageEvents ??= [];
  window.famanageEvents.push(payload);
  window.dispatchEvent(new CustomEvent<TrackPayload>('famanage:track', { detail: payload }));
}
